import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  {
    path: ':tenant/unauthorized',
    loadChildren: () => import('src/app/main/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule),
  },
  {
    path: ':tenant/service-unavailable',
    loadChildren: () => import('src/app/main/permission-error/permission-error.module').then(m => m.PermissionErrorModule),
  },
  {
    path: ':tenant/tenant',
    loadChildren: () => import('src/app/tenant-layout/tenant-layout.module').then(m => m.TenantLayoutModule),
  },
  {
    path: ':tenant',
    loadChildren: () => import('src/app/layout/layout.module').then(m => m.LayoutModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
